import { toast } from 'react-toastify';
import axios from './axios';
import { handleError, toastError, toastSuccess } from './functions';

const axiosRequest = {};

const methods = ['get', 'post', 'put', 'delete'];

methods.forEach((method) => {
    axiosRequest[method] = (url, data = null, haveLoading = false, textLoading = "Cargando...") => {
        const request = {
            onResponse: () => {},
            onCatch: () => {},
            onFinally: () => {}, 

            loadingToast: null,

            showLoadingToast: () => {
                if (haveLoading) {
                    request.loadingToast = toast.loading(textLoading);
                }
            },

            request: axios[method](url, data)
                .then(response => {
                    request.onResponse(response);
                })
                .catch(error => {
                    toastError(handleError(error));
                    request.onCatch(error);
                })
                .finally(() => {
                    if (haveLoading) toast.dismiss(request.loadingToast);
                    request.onFinally();
                }),

            onResponse: function(callback) {
                this.onResponse = callback;
                return this;
            },

            onCatch: function(callback) {
                this.onCatch = callback;
                return this;
            },

            onFinally: function(callback) {
                this.onFinally = callback;
                return this;
            }
        };

        request.showLoadingToast();

        return request;
    };
});

export default axiosRequest;


/*Llamada
axiosRequest.post("/send-email", body, mostrarLoading, textoLoading)
.onResponse((response) => {
    funcion
})
.onCatch((error) => { // Opcional: Solo se pone el .catch si necesitas manejar el error de forma personalizada
    funcion
})
.onFinally(()=>{ //Opcional
    funcion
});*/